import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { AppProductModel, ProductModel } from '@models/ProductModel';
import { SharedService } from './shared.service';
import { Country } from '@shared/models/Enums';
import { GiftcardMarketplaceModel, GiftcardModel } from '@shared/models/GiftcardModel';


@Injectable()
export class ApiProductService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // Products API //

    // GET api/admin/products/app/reads/v1/{id}
    getAppProduct(id: number): Promise<AppProductModel> {

        return this.http.get(`${this.baseUrl}/api/admin/products/app/reads/v1/${id}`, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const product = new AppProductModel(result);

                    return product;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del cliente: ${errMsg}`));
                }
            );
    }

    // GET api/admin/products/app/reads/v1
    getAllAppProducts(): Promise<AppProductModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/products/app/reads/v1`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const products: AppProductModel[] = results.map((result: any) => {

                        return new AppProductModel(result);
                    }).sort((a: AppProductModel, b: AppProductModel) => a.price - b.price);

                    return products;
                }
            );
    }

    // GET: api/admin/products/marketplace-giftcard/reads/v1
    getMarketPlaceGiftCards(country?: Country): Promise<GiftcardMarketplaceModel> {

        return this.http.get(`${this.baseUrl}/api/admin/products/marketplace-giftcard/reads/v1`, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    return new GiftcardMarketplaceModel(results);
                }
            );
    }
}
